/* KlarCar - verificador de compatibilidade */
(function () {
  function liga(raiz) {
    if (raiz.dataset.kcReady) return;
    raiz.dataset.kcReady = '1';

    var marca = raiz.querySelector('[data-kc-brand]');
    var ano = raiz.querySelector('[data-kc-year]');
    var modelo = raiz.querySelector('[data-kc-model]');
    var botao = raiz.querySelector('[data-kc-check]');
    var saida = raiz.querySelector('[data-kc-result]');
    var cfgTag = raiz.querySelector('[data-kc-config]');
    if (!marca || !ano || !modelo || !botao || !saida) return;

    var cfg = { ok: '', no: '', exceptions: '' };
    try { cfg = JSON.parse(cfgTag.textContent); } catch (e) {}

    var excecoes = (cfg.exceptions || '')
      .split('\n').map(function (l) { return l.trim().toLowerCase(); })
      .filter(function (l) { return l.length > 1; });

    function completo() {
      return marca.value !== '' && ano.value !== '' && modelo.value.trim().length > 0;
    }

    function atualiza() {
      botao.disabled = !completo();
      // qualquer mudanca invalida o resultado anterior
      saida.hidden = true;
      saida.className = 'kc-fit__result';
    }

    function verifica() {
      if (!completo()) return;
      var alvo = (marca.value + ' ' + modelo.value).toLowerCase();
      var bate = excecoes.some(function (ex) { return alvo.indexOf(ex) !== -1; });
      var texto = bate ? cfg.no : cfg.ok;
      if (!texto) return;
      saida.textContent = texto;
      saida.className = 'kc-fit__result kc-fit__result--' + (bate ? 'no' : 'ok');
      saida.hidden = false;
      if (!bate) raiz.dataset.kcOk = '1';
    }

    marca.addEventListener('change', atualiza);
    ano.addEventListener('change', atualiza);
    modelo.addEventListener('input', atualiza);
    botao.addEventListener('click', verifica);
    atualiza();
  }

  function varre() {
    document.querySelectorAll('[data-kc-fit]').forEach(liga);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', varre);
  } else {
    varre();
  }
  // o personalizador recria a secao a cada edicao
  document.addEventListener('shopify:section:load', varre);
})();
